<template>
  <div class="view-gabarit">
    <div class="column info-column">
      <div class="title">{{ $t('transportDetails.HowTransitTime') }}</div>
      <div class="info-container">
        <div class="bullet">></div>
        <div class="text">
          {{ $t('transportDetails.TransitTimeDetail1') }}
        </div>
      </div>
      <div class="info-container">
        <div class="bullet">></div>
        <div class="text">
          {{ $t('transportDetails.TransitTimeDetail2') }}
        </div>
      </div>
    </div>

    <!-- PUBLIC TRANSPORT PROVIDER -->
    <div v-if="study.public_transport_provider === 1" class="column provider-column">
      <div class="logo logo-google-maps"></div>
      <i class="icon icon-bus"></i>
      <div class="title">{{ $t('transportDetails.PublicTransport') }}</div>
      <div class="text">{{ $t('transportDetails.GoogleMaps') }}<br />({{ $t('transportDetails.GoogleMapsDetailPublic') }})</div>
    </div>
    <div v-if="study.public_transport_provider === 2 || !study.public_transport_provider" class="column provider-column">
      <div class="logo logo-kisio-digital"></div>
      <i class="icon icon-bus"></i>
      <div class="title">{{ $t('transportDetails.PublicTransport') }}</div>
      <div class="text">{{ $t('transportDetails.Kisso') }}<br />({{ $t('transportDetails.KissoDetailPublic') }})</div>
    </div>
    <div v-if="study.public_transport_provider === 3" class="column provider-column">
      <div class="logo logo-traveltime"></div>
      <i class="icon icon-bus"></i>
      <div class="title">{{ $t('transportDetails.PublicTransport') }}</div>
      <div class="text">{{ $t('transportDetails.TravelTime') }}<br />({{ $t('transportDetails.TravelTimeDetailPublic') }})</div>
    </div>

    <!-- PRIVATE TRANSPORT PROVIDER -->
    <div v-if="study.private_transport_provider === 1 || !study.private_transport_provider" class="column provider-column">
      <div class="logo logo-google-maps"></div>
      <i class="icon icon-car"></i>
      <div class="title">{{ $t('transportDetails.PrivateTransport') }}</div>
      <div class="text">{{ $t('transportDetails.GoogleMaps') }}<br />({{ $t('transportDetails.GoogleMapsDetailPrivate') }})</div>
    </div>
    <div v-if="study.private_transport_provider === 3" class="column provider-column">
      <div class="logo logo-traveltime"></div>
      <i class="icon icon-car"></i>
      <div class="title">{{ $t('transportDetails.PrivateTransport') }}</div>
      <div class="text">{{ $t('transportDetails.TravelTime') }}<br />({{ $t('transportDetails.TravelTimeDetailPrivate') }})</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: ['params'],

  computed: {
    ...mapGetters({
      study: 'study',
    }),
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.view-gabarit {
  width: 960px;
  height: 480px;
  display: flex;
  justify-content: center;
  padding: 0 0 40px;

  .column {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: 16px 24px;
    width: calc(33% + 56px);
    height: 100%;
    box-sizing: border-box;

    &:first-child {
      margin-left: -48px;
      width: 33%;
    }

    &:last-child {
      border-color: transparent;
      margin-right: -48px;
      width: 33%;
    }

    &.info-column {
      .title {
        width: 100%;
        font-size: 24px;
        font-weight: 600;
        text-align: left;
        margin: 0 0 24px;
      }
      .info-container {
        width: 100%;
        display: flex;
        margin: 0 0 16px;

        .bullet {
          color: colors.$main-color;
          width: 16px;
          margin: 0 8px 0 0;
          font-size: 18px;
          font-weight: bold;
        }
        .text {
        }
      }
    }

    &.provider-column {
      text-align: center;

      .logo {
        width: 96px;
        height: 96px;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        border-radius: 4px;
        margin: 0 0 24px;

        &.logo-kisio-digital {
          background-image: url('./../../../../assets/navitia-black.png');
          .dark & {
            background-image: url('./../../../../assets/navitia-white.png');
          }
        }
        &.logo-google-maps {
          background-image: url('./../../../../assets/googlemaps-black.png');
          .dark & {
            background-image: url('./../../../../assets/googlemaps-white.png');
          }
        }
        &.logo-traveltime {
          background-image: url('./../../../../assets/TravelTime-black.png');
          .dark & {
            background-image: url('./../../../../assets/TravelTime-white.png');
          }
        }
      }

      .icon {
        font-size: 32px;
        margin: 16px 0;
      }

      .title {
        font-size: 18px;
        font-weight: 600;
        margin: 0 0 8px;
      }
    }
  }
}
</style>

<style lang="scss">
@use '@/styles/colors.scss';

.modal-body {
  .view-gabarit {
    .column {
      border-right: solid 1px colors.$grey-color;
    }
  }
}
</style>
